import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';
import routing from './monthly_price_report.routes';

import DailyActivePowerService from '../../../components/api/daily_active_power/daily_active_power.service';
import DailyWeatherService from '../../../components/api/daily_weather/daily_weather.service';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import MathUtil from '../../../components/logic/math_util/math_util';
import CompareWeatherLogic from '../../../components/logic/compare_weather/compare_weather.logic';
import chartConfig from './monthly_price_report.config';

export class MonthlyPriceReportController {
  /*@ngInject*/
  constructor($stateParams, moment, $interval, $filter, $q, DailyActivePowerService, DateUtil, MathUtil, DailyWeatherService, CompareWeatherLogic) {
    this.id = $stateParams.id;
    this.filter = $filter;
    this.$q = $q;
    this.DailyActivePowerService = DailyActivePowerService;
    this.DailyWeatherService = DailyWeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.DateUtil = DateUtil;
    this.MathUtil = MathUtil;
    this.moment = moment;

    this.targetDate = this.moment().startOf('day').toDate();
    this.minDate = this.moment().subtract(1, 'month').toDate();
    this.maxDate = this.moment().startOf('day').toDate();

    this.categories = [];
    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.parentComponent.saConfigPromise.then(config => {
      this.billingDay = config.billing_date;
      this.baseUnitPrice = config.base_unit_price;
      this.powerUnitPrice = config.power_unit_price;
      this.contractPower = config.contract_power;

      this.updateGraph(this.targetDate, this.billingDay);
    });
  }

  updateGraph(targetDate, billingDate) {
    [this.startDate, this.endDate] = this.DateUtil.getBillingDateDomain(targetDate, billingDate);

    this.billingDate = this.moment(this.endDate).add(1, 'days').toDate();
    let numberOfDays = (this.endDate - this.startDate) / (24 * 60 * 60 * 1000);

    let startUtc = this.DateUtil.localToUTC(this.startDate);
    this.categories = [];
    for (let i = 0; i <= numberOfDays; i++) {
      this.categories.push(this.DateUtil.leapDate(startUtc, i).valueOf());
    }

    const powerQuery = angular.extend({id: this.id}, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate));
    const weatherQuery = angular.extend({sa_config_id: this.id}, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate))

    this.$q.all([
      this.DailyActivePowerService.show(powerQuery).$promise,
      this.DailyWeatherService.api.index(weatherQuery).$promise
    ]).then(responses => {
      const powers = responses[0];
      const weathers = responses[1];

      this.prices = this.formatToPrices(powers.powers);
      this.weathers = this.CompareWeatherLogic.compareDaily(weathers, this.categories);
      const y = (this.weathers.length > 0) ? 36 : null;
      this.chart.xAxis[0].update({
        categories: this.categories,
        max: numberOfDays,
        labels: {y: y}
      }, false);
      this.itemWidth = 100 / numberOfDays;

      this.chart.series[0].setData(this.prices);
      this.chart.reflow();
    });

    this.DailyActivePowerService.show(
      angular.extend({id: this.id}, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate)),
      response => {
        this.chart.xAxis[0].update({
          categories: this.categories,
          max: numberOfDays
        });

        this.prices = this.formatToPrices(response.powers);
        this.chart.series[0].setData(this.prices);
        this.chart.reflow();
      }
    );
  }

  formatToPrices(dailyActivePowers) {
    let powersIndex = 0;
    this.sumPrice = 0;
    let sumPower = 0;

    let formattedPrices = this.categories.map((category) => {
      if (!dailyActivePowers[powersIndex]) {
        return null;
      }

      let power = dailyActivePowers[powersIndex].value;
      let date = dailyActivePowers[powersIndex].date

      let utc = this.DateUtil.jstToUTC(`${date}T00:00:00+09:00`)
      if (category === utc) {
        powersIndex++;
        sumPower += power;
        return this.calcPowerPrice(power);
      } else {
        return null;
      }
    });

    this.powerPrice = this.calcPowerPrice(sumPower);
    this.basePrice = this.calcBasePrice();
    this.sumPrice = this.calcPriceWithBase(sumPower);

    return formattedPrices;
  }

  calcPowerPrice(power) {
    return this.powerUnitPrice * power;
  }

  calcBasePrice() {
    return this.contractPower * this.baseUnitPrice;
  }

  calcPriceWithBase(power) {
    return this.MathUtil.add(this.calcBasePrice(), this.calcPowerPrice(power));
  }
}

export default angular.module('leptonApp.monthlyPriceReport', [uiRouter, moment, DailyActivePowerService, DateUtil, MathUtil, DailyWeatherService, CompareWeatherLogic])
  .config(routing)
  .component('monthlyPriceReport', {
    require: {parentComponent: '^demandReportShow'},
    template: require('./monthly_price_report.html'),
    controller: MonthlyPriceReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/price_report/monthly/monthly_price_report.component.js